var map = {
	"./de.json": [
		"4039",
		"chunk-2d0bfed8"
	],
	"./en.json": [
		"71fa",
		"chunk-2d0d660b"
	],
	"./es.json": [
		"b778",
		"chunk-2d2102ac"
	],
	"./fr.json": [
		"1c0d",
		"chunk-2d0b60fc"
	],
	"./it.json": [
		"0d56",
		"chunk-2d0af0cb"
	],
	"./ko.json": [
		"b532",
		"chunk-2d20faa8"
	],
	"./pt-br.json": [
		"e67a",
		"chunk-2d225c31"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f346";
module.exports = webpackAsyncContext;